import { storeInstance } from './../../store.js';
import * as types from '../NGUD/types';
import Message from '@/components/shared/mixins/Message.js';

const state = {
  indicesTematicos: [],
  indiceTematicoCiudad: [],
  indiceTematico: null,
  indicesTematicosVisibles: []
};

const getters = {
  [types.ALL_INDICES_TEMATICOS]: state => {
    return state.indicesTematicos;
  },
  [types.INDICE_TEMATICO_CIUDAD]: () => {
    return storeInstance.state.NGUD.CiudadSelected !== null ? storeInstance.state.NGUD.CiudadSelected.indicesTematicos : [];
  },
  [types.INDICE_TEMATICO]: state => {
    return state.indiceTematico;
  },
  [types.ALL_INDICES_TEMATICOS_VISIBLES]: state => {
    return state.indicesTematicosVisibles.filter(e => e.visible);
  }
};

const mutations = {
  [types.MUTATE_ALL_INDICES_TEMATICOS]: (state, payload) => {
    state.indicesTematicos = payload;
  },
  [types.MUTATE_INDICE_TEMATICO_CIUDAD]: (state, payload) => {
    state.indiceTematicoCiudad = payload;
  },
  [types.MUTATE_INDICE_TEMATICO]: (state, payload) => {
    state.indiceTematico = payload;
  },
  [types.MUTATE_ALL_INDICES_TEMATICOS_VISIBLES]: (state, payload) => {
    state.indicesTematicosVisibles = payload;
  }
};

const actions = {
  [types.ACTION_GET_ALL_INDICES_TEMATICOS]: ({ commit }) => {
    let request = { controller: '/IndiceTematico' };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_ALL_INDICES_TEMATICOS, response.data);
          commit(types.MUTATE_ALL_INDICES_TEMATICOS_VISIBLES, response.data);
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_GET_INDICE_TEMATICO]: ({ commit }, payload) => {
    let indiceTematicoId = payload.idIndiceTematico;
    let request = { controller: '/IndiceTematico/' + indiceTematicoId };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/getSuit', request)
        .then(response => {
          commit(types.MUTATE_INDICE_TEMATICO, response.data);
          resolve(response.data);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_NEW_INDICE_TEMATICO]: ({ commit }, payload) => {
    let request = {
      controller: '/IndiceTematico',
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.newIndiceTematico
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/postFile', request)
        .then(response => {
          storeInstance
            .dispatch(types.ACTION_GET_INDICE_TEMATICO, { idIndiceTematico: response.data.id })
            .then(response => {
              commit(types.MUTATE_INDICE_TEMATICO, response.data);
              Message.showMessage('El índice temático se ha guardado con éxito.');
              resolve(response);
            });
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_SAVE_INDICE_TEMATICO]: ({ commit }, payload) => {
    let request = {
      controller: '/IndiceTematico/' + payload.idIndiceTematico,
      filter: {},
      contentType: 'multipart/form-data',
      body: payload.newIndiceTematico
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/putFile', request)
        .then(response => {
          commit(types.MUTATE_INDICE_TEMATICO, payload.newIndiceTematico);
          Message.showMessage('El índice temático se ha actualizado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  },
  [types.ACTION_DELETE_INDICE_TEMATICO]: ({ commit }, payload) => {
    let request = {
      controller: '/IndiceTematico/' + payload.idIndiceTematico,
      filter: {}
    };
    return new Promise((resolve, reject) => {
      storeInstance
        .dispatch('NGUD/deletes', request)
        .then(response => {
          commit(types.MUTATE_ALL_INDICES_TEMATICOS, payload.items);
          Message.showMessage('El índice temático se ha eliminado con éxito.');
          resolve(response);
        })
        .catch(err => {
          Message.showError(err.message);
          reject(err);
        });
    });
  }
};

export default {
  actions,
  state,
  getters,
  mutations
};
